export default "__VITE_ASSET__8b039f9f__"